function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import memoize from 'memoize-one';
import classNames from 'classnames';
import { Button, DropdownMenu } from '@deephaven/components';
import { vsTrash, vsTriangleDown } from '@deephaven/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Type as FilterType, getLabelForNumberFilter, getLabelForTextFilter, getLabelForDateFilter } from '@deephaven/filters';
import Log from '@deephaven/log';
import { TableUtils } from '@deephaven/jsapi-utils';
import "./LinkerLink.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('LinkerLink');

/** The constant for how droopy the links are. Increase for more droopiness. */
var DROOP = 0.015;
var DROOP_EXPONENT = 1.5;
var TRIANGLE_HEIGHT = 12;
var TRIANGLE_BASE = 12;
var TRIANGLE_TIP = 2;
var TRIANGLE_HYPOTENUSE = Math.sqrt((TRIANGLE_BASE * 0.5) ** 2 + TRIANGLE_HEIGHT ** 2);
var TRIANGLE_THETA = Math.asin(TRIANGLE_BASE * 0.5 / TRIANGLE_HEIGHT);
var CLIP_RADIUS = 15;
var HALF_PI = Math.PI * 0.5;
export class LinkerLink extends Component {
  /**
   * Make an SVG path for a circle at the specified coordinates.
   * @param x The x coordinate for the centre of the circle
   * @param y The y coordinate for the centre of the circle
   * @param r Radius of the circle
   * @returns The SVG string path
   */
  static makeCirclePath(x, y, r) {
    return "M ".concat(x, " ").concat(y, " m -").concat(r, ",0 a ").concat(r, ",").concat(r, " 0 1,0 ").concat(r * 2, ",0 a ").concat(r, ",").concat(r, " 0 1,0 -").concat(r * 2, ",0 z");
  }
  static getLabelForLinkFilter(columnType, filterType) {
    try {
      if (TableUtils.isNumberType(columnType) || TableUtils.isCharType(columnType)) {
        return getLabelForNumberFilter(filterType);
      }
      if (TableUtils.isTextType(columnType)) {
        return getLabelForTextFilter(filterType);
      }
      if (TableUtils.isDateType(columnType)) {
        return getLabelForDateFilter(filterType);
      }
      if (TableUtils.isBooleanType(columnType)) {
        if (filterType === FilterType.eq) {
          return 'is equal to';
        }
        if (filterType === FilterType.notEq) {
          return 'is not equal to';
        }
      }
      throw new Error("Unrecognized column type: ".concat(columnType));
    } catch (e) {
      log.warn(e);
      return '';
    }
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "getOperators", memoize((linkId, columnType) => {
      var onOperatorChanged = this.props.onOperatorChanged;
      var filterTypes = TableUtils.getFilterTypes(columnType);
      if (TableUtils.isBooleanType(columnType)) {
        filterTypes = [FilterType.eq, FilterType.notEq];
      }
      return filterTypes.flatMap((type, index) => {
        // Remove case-insensitive string comparisons
        if (type === 'eqIgnoreCase' || type === "notEqIgnoreCase") {
          return [];
        }
        var symbol = '';
        if (type === 'startsWith') {
          symbol = 'a*';
        } else if (type === 'endsWith') {
          symbol = '*z';
        } else {
          symbol = TableUtils.getFilterOperatorString(type);
        }
        return [{
          title: LinkerLink.getLabelForLinkFilter(columnType, type),
          icon: /*#__PURE__*/_jsx("b", {
            children: symbol
          }),
          action: () => onOperatorChanged(linkId, type),
          order: index
        }];
      });
    }));
    this.handleClick = this.handleClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.getDropdownActions = this.getDropdownActions.bind(this);
    this.state = {
      isHovering: undefined
    };
  }
  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
    var _this$props = this.props,
      id = _this$props.id,
      onClick = _this$props.onClick,
      onDelete = _this$props.onDelete;
    if (event.altKey) {
      onDelete(id);
    } else {
      onClick(id);
    }
  }
  handleMouseEnter() {
    this.setState({
      isHovering: true
    });
  }
  handleMouseLeave() {
    this.setState({
      isHovering: false
    });
  }
  handleDelete() {
    var _this$props2 = this.props,
      id = _this$props2.id,
      onDelete = _this$props2.onDelete;
    onDelete(id);
  }
  getDropdownActions() {
    var _this$props3 = this.props,
      id = _this$props3.id,
      startColumnType = _this$props3.startColumnType;
    if (startColumnType != null) {
      return this.getOperators(id, startColumnType);
    }
    return [];
  }
  render() {
    var _this$props4 = this.props,
      className = _this$props4.className,
      operator = _this$props4.operator,
      isSelected = _this$props4.isSelected,
      x1 = _this$props4.x1,
      y1 = _this$props4.y1,
      x2 = _this$props4.x2,
      y2 = _this$props4.y2,
      id = _this$props4.id,
      startColumnType = _this$props4.startColumnType,
      type = _this$props4.type;
    var isHovering = this.state.isHovering;

    // Path between the two points
    var len = Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
    var theta = Math.atan2(y2 - y1, x2 - x1);
    var xMult = Math.sin(theta);
    var yMult = Math.cos(theta) + 2;
    var maxX = window.innerWidth;
    var maxY = window.innerHeight;
    var minX = 0;
    var minY = 0;
    var qx = Math.max(minX, Math.min(x1 + (x2 - x1) / 2 + xMult * (len * DROOP) ** DROOP_EXPONENT, maxX));
    var qy = Math.max(minY, Math.min(y1 + (y2 - y1) / 2 + yMult * (len * DROOP) ** DROOP_EXPONENT, maxY));
    var path = "M ".concat(x1, " ").concat(y1, " Q ").concat(qx, " ").concat(qy, " ").concat(x2, " ").concat(y2);

    // path for a 100%, 100% rect, then two paths for circles at point
    var selectClipPath = "M ".concat(minX, " ").concat(minY, " L ").concat(minX, " ").concat(maxY, " L ").concat(maxX, " ").concat(maxY, " L ").concat(maxX, " ").concat(minY, " z\n    ").concat(LinkerLink.makeCirclePath(x1, y1, CLIP_RADIUS), "\n    ").concat(LinkerLink.makeCirclePath(x2, y2, CLIP_RADIUS));
    var clipPathId = "link-select-clip-".concat(id);

    // Calculate location of the end triangle
    // We draw it instead of using markers to allow for transitions in the style
    var endTheta = Math.atan2(y2 - qy, x2 - qx);
    var t2theta = endTheta - TRIANGLE_THETA + Math.PI;
    var t3theta = endTheta + TRIANGLE_THETA + Math.PI;
    var tx1 = x2 + Math.cos(endTheta) * TRIANGLE_TIP;
    var ty1 = y2 + Math.sin(endTheta) * TRIANGLE_TIP;
    var tx2 = tx1 + Math.cos(t2theta) * TRIANGLE_HYPOTENUSE;
    var ty2 = ty1 + Math.sin(t2theta) * TRIANGLE_HYPOTENUSE;
    var tx3 = tx1 + Math.cos(t3theta) * TRIANGLE_HYPOTENUSE;
    var ty3 = ty1 + Math.sin(t3theta) * TRIANGLE_HYPOTENUSE;
    var points = "".concat(tx1, ",").concat(ty1, " ").concat(tx2, ",").concat(ty2, " ").concat(tx3, ",").concat(ty3);

    // Button offset calculations
    var midX = 0.25 * x1 + 0.5 * qx + 0.25 * x2;
    var midY = 0.25 * y1 + 0.5 * qy + 0.25 * y2;
    var dMidX = qx - x1 + (x2 - qx);
    var dMidY = qy - y1 + (y2 - qy);
    var slopeAtMid = dMidY / dMidX;
    var DISTANCE_FROM_MID = 20;
    var topOffsetX = DISTANCE_FROM_MID / Math.sqrt(1 + slopeAtMid ** 2);
    var topOffsetY = topOffsetX * slopeAtMid;
    var bottomOffsetX = topOffsetX * -1;
    var bottomOffsetY = topOffsetY * -1;
    if (!Number.isFinite(slopeAtMid)) {
      bottomOffsetX = 10;
      bottomOffsetY = 5;
      topOffsetX = 10;
      topOffsetY = -35;
    } else if (slopeAtMid > 0) {
      topOffsetX *= -1;
      topOffsetY *= -1;
      bottomOffsetX *= -1;
      bottomOffsetY *= -1;
      bottomOffsetX -= 50 - 10 * (Math.abs(theta) % HALF_PI);
      bottomOffsetY += 10 * (Math.abs(theta) % HALF_PI);
      topOffsetX -= 50 - 10 * (Math.abs(theta) % HALF_PI);
      topOffsetY += 10 * (Math.abs(theta) % HALF_PI);
    } else if (slopeAtMid < 0) {
      bottomOffsetX += 10 * (Math.abs(theta) % HALF_PI);
      bottomOffsetY += 10 * (Math.abs(theta) % HALF_PI);
      topOffsetX += 10 * (Math.abs(theta) % HALF_PI);
      topOffsetY += 10 * (Math.abs(theta) % HALF_PI);
    } else {
      bottomOffsetX = 15;
      bottomOffsetY = 10;
      topOffsetX = -25;
      topOffsetY = 10;
    }
    var symbol = '';
    if (operator !== undefined) {
      if (operator === 'startsWith') {
        symbol = 'a*';
      } else if (operator === 'endsWith') {
        symbol = '*z';
      } else {
        symbol = TableUtils.getFilterOperatorString(operator);
      }
    }
    var showOperator = type !== 'chartLink' && type !== 'filterSource';
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("svg", {
        className: classNames(className, {
          hovering: isHovering
        }),
        children: [/*#__PURE__*/_jsx("clipPath", {
          id: clipPathId,
          children: /*#__PURE__*/_jsx("path", {
            d: selectClipPath,
            clipRule: "evenodd"
          })
        }), /*#__PURE__*/_jsx("path", {
          className: "link-select",
          d: path,
          onClick: this.handleClick,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          clipPath: "url(#".concat(clipPathId, ")"),
          "data-testid": "link-select"
        }), /*#__PURE__*/_jsx("path", {
          className: "link-background",
          d: path
        }), /*#__PURE__*/_jsx("path", {
          className: "link-foreground",
          d: path
        }), /*#__PURE__*/_jsx("circle", {
          className: "link-dot",
          cx: x1,
          cy: y1,
          r: "5"
        }), /*#__PURE__*/_jsx("polygon", {
          className: "link-triangle",
          points: points
        })]
      }), startColumnType != null && isSelected && /*#__PURE__*/_jsxs(_Fragment, {
        children: [showOperator && /*#__PURE__*/_jsx(Button, {
          kind: "primary",
          className: "btn-fab btn-operator",
          style: {
            top: midY + (slopeAtMid >= 0 ? topOffsetY : bottomOffsetY),
            left: midX + (slopeAtMid >= 0 ? topOffsetX : bottomOffsetX)
          },
          onClick: () => {
            // no-op: click is handled in `DropdownMenu'
          },
          icon: /*#__PURE__*/_jsxs("div", {
            className: "fa-md fa-layers",
            children: [/*#__PURE__*/_jsx("b", {
              children: symbol
            }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsTriangleDown,
              transform: "right-8 down-9 shrink-5"
            })]
          }),
          tooltip: "Change comparison operator",
          children: /*#__PURE__*/_jsx(DropdownMenu, {
            actions: this.getDropdownActions,
            popperOptions: {
              placement: 'bottom-start'
            }
          })
        }), /*#__PURE__*/_jsx(Button, {
          kind: "primary",
          className: "btn-fab btn-delete",
          style: {
            top: midY + (slopeAtMid < 0 ? topOffsetY : bottomOffsetY),
            left: midX + (slopeAtMid < 0 ? topOffsetX : bottomOffsetX)
          },
          onClick: this.handleDelete,
          icon: vsTrash,
          tooltip: "Delete"
        })]
      })]
    });
  }
}
_defineProperty(LinkerLink, "defaultProps", {
  className: '',
  isSelected: false,
  onClick() {
    // no-op
  },
  onDelete() {
    // no-op
  }
});
export default LinkerLink;
//# sourceMappingURL=LinkerLink.js.map